import React, { useEffect } from 'react';
import { useController, useSuspense } from '@rest-hooks/react';
import { useParams } from 'react-router-dom';

import OrderResource from 'resources/organization/OrderResource';
import OrderDownloadResource from 'resources/organization/OrderDownloadResource';
import OrganizationResource from 'resources/organization/OrganizationResource';

import OrderFilter from './OrderFilter';

import DataSelectionTable from 'components/DataTable/DataSelectionTable';
import WithPermission from 'components/WithPermission';
import SalesFallback from 'components/fallbacks/Sales';
import OrderStats from 'components/OrderStats';

import { downloadCSV } from 'utils/downloadFile';
import { ordersColumns } from 'utils/tables/columns/ordersColumns';
import usePaginationAndFilteringController from 'utils/usePaginationAndFilteringController';
import { useError } from 'utils/useErrorController';
import useOrderDetailsModal from 'utils/useOrderDetailsModal';

const OrdersTabContent = () => {

  const { handleError } = useError();
  const params = useParams();
  const organizationId = parseInt(params.organizationId);
  const organization = useSuspense(OrganizationResource.detail(), { id: organizationId });

  const {
    objectState,
    fetchData,
    handlePageChange,
    handleFilterChange,
  } = usePaginationAndFilteringController({
      fetchDataResource: OrderResource,
      fetchDataParams: { organization_id: organizationId },
  })

  useEffect(() => {
    fetchData(1, {status: "completed"});
  }, []);

  const {fetch} = useController();

  const handleDownload = async (format = 'default') => {
    try {
      const downloadParams = {
        organization_id: organizationId,
        ...objectState.filteringParams,
        ...(format === 'saft' && { format: 'saft' }),
      };
      const response = await fetch(OrderDownloadResource.list(), downloadParams);
      const filename = format === 'saft' ? 'orders_saft.csv' : 'orders.csv';
      downloadCSV(response, filename, 'text/csv');
    } catch (error) {
      handleError(error);
    }
  };

  const {handleOpenOrderDetails, OrderDetailsModalComponent} = useOrderDetailsModal();

  return (
    <WithPermission permission={'hasSales'} fallback={<SalesFallback />}>

      <OrderStats orders={objectState.filteredObjects} />
      <div style={{ flexGrow: 1 }}>
        <DataSelectionTable 
          records={objectState.filteredObjects}
          columns={ordersColumns(handleOpenOrderDetails)}
          onClick={handleDownload}
          showSaftModal={organization?.country === 'PT'}
          serverPaginationProps={{
            paginationServer: true,
            paginationTotalRows: objectState.totalCount,
            page: objectState.page,
            onChangePage: handlePageChange
          }}
          filter={
            <OrderFilter
              onChange={handleFilterChange}
            />
          }
        />
      </div>

      <OrderDetailsModalComponent />

    </WithPermission>
  );
};

export default OrdersTabContent;
